import { useWorkflow } from '../../workflow/hooks';
import { useNavigate } from '@tanstack/react-router';
import { useSubmit } from '../../hooks/useSubmit';
import {
  Button,
  type ButtonCommonProps,
  type ButtonProps,
  type DefaultShapeProps,
} from '@repo/ui/Button';
import { Text } from '../Language/Language';
import { useFormContext } from 'react-hook-form';

// Use ButtonCommonProps + DefaultShapeProps to avoid discriminated union issues with Partial<ButtonProps>
export const SubmitButton = (
  props: Partial<ButtonCommonProps & DefaultShapeProps>,
) => {
  const { complete, data, retailer, isSaving } = useWorkflow();
  const navigate = useNavigate();
  const { formState } = useFormContext();

  const { isLoading, isValid } = formState;

  const doesButtonAppearDisabled = isLoading || !isValid || isSaving;

  const { submit, isLoading: isSubmitLoading } = useSubmit({
    formData: data,
    onSuccess: () => {
      complete();
      navigate({
        to: '/$retailer/complete',
        params: { retailer: retailer ?? 's' },
        search: true,
      });
    },
  });

  const handleSubmit: ButtonProps['onClick'] = (e) => {
    if (!isValid || isSaving) return;
    e.preventDefault();
    submit();
  };

  return (
    <Button
      ariaDisabled={doesButtonAppearDisabled}
      isLoading={isSubmitLoading}
      onClick={handleSubmit}
      size="lg"
      type="submit"
      variant="primary"
      {...props}
    >
      <Text langKey="pdx.review.submit_button" />
    </Button>
  );
};
